"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _payloads = require("./payloads");

var _workspaces = _interopRequireDefault(require("./workspaces"));

var _default = (0, _reduxObservable.combineEpics)(_payloads.fetchPayload, _workspaces.default);

exports.default = _default;
module.exports = exports.default;